import classNames from "classnames"
import React from "react";
import {
  section,
  s,
  m,
  l,
  responsive,
  x_s,
  x_m,
  x_xl,
  mt,
  mtb,
  mb,
  content,
  widthS,
  widthM,
  left,
  right,
  center,
  footer
} from "./section.module.scss";

interface Props {
  className?: string
  id?: string
  appearance?: "content" | "footer"
  children: React.ReactNode
  padding?: "s" | "m" | "l" | "responsive" | "x_xl" | "x_m" | "x_s"
  width?: "widthS" | "widthM"
  margin?: "mb" | "mt" | "mtb"
  align?: "left" | "right" | "center"
}

export default React.memo((props: Props) => {
  const { className, id, children, padding, margin, appearance, width, align } = props
  const classes = classNames(
    section,
    {
      [s]: padding === "s",
      [m]: padding === "m",
      [l]: padding === "l",
      [responsive]: padding === "responsive",
      [x_xl]: padding === "x_xl",
      [x_m]: padding === "x_m",
      [x_s]: padding === "x_s",
      [mt]: margin === "mt",
      [mb]: margin === "mb",
      [mtb]: margin === "mtb",
      [content]: appearance === "content",
      [footer]: appearance === "footer",
      [widthS]: width === "widthS",
      [widthM]: width === "widthM",
      [left]: align === "left",
      [right]: align === "right",
      [center]: align === "center",
    },
    className
  )

  return (
    <section id={id} className={classes}>
      {children}
    </section>
  )
});
